// extracted by mini-css-extract-plugin
export default {"form":"ContactForm_form__zqkUM","form__label":"ContactForm_form__label__MOlzG","form__input":"ContactForm_form__input__xCYsn","form__button":"ContactForm_form__button__oxBoE"};